// @flow
import React from 'react';
import { Form, FormikProps, Formik, FormikHelpers, FormikValues } from 'formik';
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
import api from 'apiClient/api';
import { StringUtil } from 'utils/StringUtil';
import { FormButton } from 'components/molecules/formButton';
import { FormDropdown } from 'components/molecules/formDropdown';
import { FormInput } from 'components/molecules/formInput';
import mailIcon from 'assets/images/mail.png';
import messageIcon from 'assets/images/message.png';
// eslint-disable-next-line
import styles from "./styles.scss";

const SEND_EMAIL_API_ENDPOINT = 'sendEmailOrSms.json';
const POSTLEAD_API_ENDPOINT = 'postLead';

type Props = {
  onSubmitSuccess: () => void,
  shareLink: string,
  isMobile: boolean,
  callPostLeadAPI?: boolean,
};

type State = {
  data: {
    type: 'sms' | 'email',
    email_id?: string,
    phone_number?: string,
  },
};

const initialState: State = {
  data: {
    // type: 'sms',
    type: 'email',
    email_id: '',
    phone_number: '',
  },
};

const options = [
  // { value: 'sms', label: 'SMS' }, Commenting for phase 1
  { value: 'email', label: 'Email' },
];

export class ShareForm extends React.Component<Props, State> {
  formikProps: FormikProps<State> = null;

  constructor(props: Props) {
    super(props);
    this.state = { ...initialState };
  }

  render = () => {
    const buttonMode = this.props.isMobile ? 'transparent' : 'dark';

    return (
      <div className={'share-form'}>
        <Formik
          initialValues={this.state.data}
          onSubmit={this.onSubmit}
          validationSchema={this.getSchema()}
        >
          {(props: FormikProps<State>) => {
            this.formikProps = props;

            return (
              <Form>
                <FormDropdown
                  name={'type'}
                  label={''}
                  placeholder={''}
                  options={options}
                  value={props.values['type']}
                  onValueChange={this.onChangeShareType}
                />
                <img
                  className={'share-type-icon'}
                  src={props.values['type'] === 'sms' ? messageIcon : mailIcon}
                  alt={'icon'}
                />
                {props.values['type'] === 'email' && (
                  <FormInput
                    id={'share-emailaddress'}
                    name={'email_id'}
                    label={'Enter email address'}
                    placeholder={'Enter email address'}
                    type={'email'}
                    value={props.values['email_id']}
                  />
                )}
                {/*{props.values['type'] === 'sms' && (*/}
                {/*  <FormInput*/}
                {/*    id={'share-mobilenumber'}*/}
                {/*    name={'phone_number'}*/}
                {/*    label={'Enter mobile number'}*/}
                {/*    placeholder={'Enter mobile number'}*/}
                {/*    value={props.values['phone_number']}*/}
                {/*    type={'number'}*/}
                {/*    pattern={'[0-9]*'}*/}
                {/*  />*/}
                {/*)}*/}
                <FormButton
                  text={'Send'}
                  disabled={props.isSubmitting}
                  mode={buttonMode}
                  minimal={true}
                />
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  onChangeShareType = (value: 'sms' | 'email') => {
    this.formikProps.setFieldValue('email_id', '');
    this.formikProps.setFieldTouched('email_id', false);
    // this.formikProps.setFieldValue('phone_number', '');
    // this.formikProps.setFieldTouched('phone_number', false);
    this.formikProps.setErrors({});
  };

  // TODO: Common component for toast?
  onSubmit = (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
    actions.setSubmitting(true);
    const { hide: hideLoader } = cogoToast.loading(
      'Submitting your information...',
      {
        hideAfter: 0,
      }
    );
    const promisesArray = [];
    const link = this.props.shareLink;
    const sendEmailPayload = { ...values, link: link };
    const sendEmailPromise = api.post(
      SEND_EMAIL_API_ENDPOINT,
      sendEmailPayload
    );
    promisesArray.push(sendEmailPromise);

    // adding this to call POST LEAD api for the homes / product details / project details
    if (this.props.callPostLeadAPI) {
      const postLeadPayload = {
        emailaddress: values['email_id'],
        lastname: link,
        mobilenumber: 9900078000, // As discussed we dont have mobile number at this place , so suggested by manjunath adding default mobile number
      };
      const postLeadPromise = api.post(POSTLEAD_API_ENDPOINT, postLeadPayload);
      promisesArray.push(postLeadPromise);
    }

    Promise.all(promisesArray)
      .then(res => {
        hideLoader();
        this.props.onSubmitSuccess && this.props.onSubmitSuccess();
        setTimeout(() => {
          cogoToast.success('Submitted your information successfully!');
        }, 300);
        actions.resetForm({ ...initialState });
      })
      .catch(error => {
        hideLoader();
        setTimeout(() => {
          cogoToast.error('Failed to submit your information');
        }, 300);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });

    // api
    //   .post(SEND_EMAIL_API_ENDPOINT, payload)
    //   .then(res => {
    //     hideLoader();
    //     this.props.onSubmitSuccess && this.props.onSubmitSuccess();
    //     setTimeout(() => {
    //       cogoToast.success('Submitted your information successfully!');
    //     }, 300);
    //     actions.resetForm({ ...initialState });
    //   })
    //   .catch(error => {
    //     hideLoader();
    //     setTimeout(() => {
    //       cogoToast.error('Failed to submit your information');
    //     }, 300);
    //   })
    //   .finally(() => {
    //     actions.setSubmitting(false);
    //   });
  };

  getSchema = () => {
    const schema = {
      type: Yup.string().required(),
      email_id: Yup.string()
        .email('Please enter a valid email')
        .when('type', function(v) {
          if (v === 'email') {
            return this.required('Please enter Email address');
          }
        }),
      // phone_number: Yup.string()
      //   .matches(
      //     StringUtil.regexPatterns.phone,
      //     'Please enter a valid mobile number'
      //   )
      //   .when('type', function(v) {
      //     if (v === 'sms') {
      //       return this.required('Please enter your mobile number');
      //     }
      //   }),
    };

    return Yup.object().shape(schema);
  };
}
